export default function preventBrowserTranslation(doc = document) {
  const root = doc.documentElement;
  if (root) {
    root.setAttribute('translate', 'no');
    root.classList.add('notranslate');
  }

  const { body } = doc;
  if (body) {
    body.setAttribute('translate', 'no');
    body.classList.add('notranslate');
  }

  const { head } = doc;
  if (!head) {
    return;
  }

  let meta = head.querySelector('meta[name="google"][content="notranslate"]');
  if (!meta) {
    meta = head.querySelector('meta[name="google"]') || doc.createElement('meta');
    meta.setAttribute('name', 'google');
    meta.setAttribute('content', 'notranslate');
  }

  if (!meta.parentNode) {
    head.appendChild(meta);
  }
}
